import styled from 'styled-components';
import { Link } from "react-router-dom";
import colors from 'constants/colors';

export const Menu = styled.nav`
  width: 100%;
  height: 56px;
  list-style: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 64px;
  background-color: ${colors.black2};
  padding: 16px;
  margin-bottom: 16px;
`;

export const Item = styled(Link)`
  color: ${({ active }) => (active ? colors.white : colors.silver)};
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.5px;
  text-decoration: ${({ active }) => (active ? `underline` : `none`)};

  /* :hover {
    color: ${colors.white};
    background-color: ${colors.darkBlue};
    border-left: 5px solid ${colors.lightBlue};
    padding-left: 17px;
  } */
`;